import Scroll from '@/lib/scroll'

class DefaultScroll extends Scroll {

  extendCache(cache) {

    cache.isVisible = true;
    return cache;
  }

  cacheBoundings() {

    super.cacheBoundings();

    this.options.container.style.height =  this.options.inner.getBoundingClientRect().height+'px';
  }

  // set original position of every el before scroll
  prepareElements() {

    for (let index = 0; index < this.vars.triggersCache.length; index++) {
      const cache = this.vars.triggersCache[index];
      if(!cache) return false;

      this.prepareElement(cache);
    }
  }

  // set original position of el outside of view
  prepareElement(cache) {

    const position = this.getPosition(cache);

    if(!position.isVisible) {
      cache.el.classList.remove('in-view');
    }
  }

  onScroll(e) {

    if(typeof this.vars.triggersCache === 'undefined') return;

    if(this.state.paused) return;

    for (let index = 0; index < this.vars.triggersCache.length; index++) {
      this.inView(index);
    }
  }

  getPosition(cache) {

    const top = Math.round(cache.top - this.vars.current.scrollY);
    const bottom = Math.round(cache.bottom - this.vars.current.scrollY);

    const isAbove = (bottom < 0 - this.options.padding.bottom);
    const isBelow = (top > this.vars.windowInnerHeight + this.options.padding.top);

    return {
      top: top,
      bottom: bottom,
      isAbove: isAbove,
      isBelow: isBelow,
      isVisible: (top < this.vars.windowInnerHeight + this.options.padding.bottom) && (bottom > 0 - this.options.padding.top)
    }
  }

  inView(index) {

    if(!this.vars.triggersCache) return false;

    const cache = this.vars.triggersCache[index];
    if(!cache) return false;

    if(cache.options.header) {
      if(this.vars.current.scrollY !== 0) {
        cache.el.classList.add('has-scrolled');
        cache.options.header = false;
      }
    }

    const position = this.getPosition(cache);

    if(position.isVisible) {
      cache.el.classList.add('in-view');
    } else {
      cache.el.classList.remove('in-view');
    }
  }

  virtualScroll() {

    if (this.trim(this.vars.current.scrollY) !== this.options.targetY) {
      this.options.targetY = this.options.targetY+Math.ceil(this.options.lerp*(this.vars.current.scrollY-this.options.targetY));
      this.options.targetY = this.trim(this.options.targetY);

      this.options.inner.style[this.options.transformProperty] = this.getTransform(this.options.targetY);
    }
  }

  update() {

    super.update();

    this.options.virtualScroll && this.virtualScroll();
  }

  getTransform(value) {
    return 'translate3d(0,' + -value + 'px,0)';
  }

  trim(value) {
    return parseInt(value, 10);
  }

}


export default {

  methods: {
    initScroll(scrollableEl) {
      if(!this.store.scrollFx) return true;

      const triggers = this.$el.querySelectorAll('.on-scroll');
      this.scroll = new DefaultScroll({
        lerp: 0.2,
        scrollEl: (typeof scrollableEl !== 'undefined') ? scrollableEl : false,
        virtualScroll: this.store.virtualScroll,
        container: this.$refs.container,
        inner: this.$refs.inner,
        targetY: 0,
        triggers: triggers,
        padding: {
          top: 100, // outside
          bottom: -75 // inside
        },
        delegate: this
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/mixins/default_scroll.js